import React from 'react';
import { Plugin, CustomEditor } from '../types';

const HorizontalRulePlugin: Plugin = {
  name: 'horizontalRule',
  
  commands: {
    insertHorizontalRule: (editor: CustomEditor) => {
      // TODO: Implement horizontal rule insertion
      console.log('Insert horizontal rule');
    }
  }
};

export default HorizontalRulePlugin; 